




























import { Component, Prop, Vue } from "vue-property-decorator";
import ContentRenderComponent from "@/components/render/ContentRender.vue";
import { RenderTemplateModel, RenderContentModel, Button } from "@/services/render/types";
import { renderTemplate } from "@/services/render/renderService";
import { Getter } from "vuex-class";
import PreviewModalHeader from "@/components/common/preview/PreviewModalHeader.vue";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";

const namespace: string = "authentication";

@Component({
    components: {
        ContentRenderComponent,
        PreviewModalHeader,
        PreviewSidebar
    }
})
export default class TemplatePreviewModal extends Vue {
    @Getter("getToken", { namespace }) getToken!: string;

    // local
    templateId = "";
    contentRenderModel = {
        height: 0,
        width: 0,
        renderChannels: [] as Array<RenderContentModel>,
        buttons: [] as Array<Button>
    } as RenderTemplateModel;

    dateTime = "";
    contentRenderReload = 0;
    scale = 1;
    fitScale = 0;
    bgColor = "#ffffff";
    name = "";
    allowTransition = false;

    open(templateId: string, name: string) {
        this.allowTransition = false;
        this.name = name;
        this.templateId = templateId;
        this.$bvModal.show("modal-templatePreview");
    }

    hide() {
        this.$bvModal.hide("modal-templatePreview");
    }

    // methods
    renderTemplate(value: string, keepZoom = false) {
        this.dateTime = value;
        renderTemplate(this.templateId, this.dateTime).then(
            response => {
                this.contentRenderReload += 1;
                this.contentRenderModel = response;
                const oldScale = this.scale;
                this.setScale();
                if (keepZoom) this.scale = oldScale;
            }
        );
    }

    fullScreen() {
        return { name: "templatepreview", params: { templateId: this.templateId } };
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 70) / this.contentRenderModel.width;
        var scaleY = (window.innerHeight / 100 * 74) / this.contentRenderModel.height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    onScale(value: number) {
        this.scale = value;
        this.allowTransition = true;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    // computed
    get model(): RenderTemplateModel {
        return this.contentRenderModel;
    }

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.contentRenderModel.height}px`,
            width: `${this.contentRenderModel.width}px`
        };
    }
}
